const inputPriceRegExp = /^\d{0,6}(,\d{3})*(\.\d{2})?$/

export { inputPriceRegExp }
